export default function CertificazioniSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Certificazioni e Riconoscimenti
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Il BCI ha ottenuto importanti riconoscimenti accademici e professionali 
            che ne attestano la validità scientifica e l'affidabilità metodologica.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-[#E879F9] to-[#E879F9] rounded-2xl flex items-center justify-center mx-auto mb-6">
              <i className="ri-medal-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2">ISO 10668:2010</h3>
            <p className="text-gray-600 text-sm">Conformità standard internazionale per la valutazione monetaria del brand</p>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-[#22C55E] to-[#22C55E] rounded-2xl flex items-center justify-center mx-auto mb-6">
              <i className="ri-graduation-cap-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2">Peer Review</h3>
            <p className="text-gray-600 text-sm">Pubblicazione su Journal of Brand Management (Springer Nature)</p>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-[#E879F9] to-[#E879F9] rounded-2xl flex items-center justify-center mx-auto mb-6">
              <i className="ri-bank-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2">Banca d'Italia</h3>
            <p className="text-gray-600 text-sm">Metodologia riconosciuta per valutazioni bancarie e finanziarie</p>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-[#22C55E] to-[#22C55E] rounded-2xl flex items-center justify-center mx-auto mb-6">
              <i className="ri-government-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2">Agenzia Entrate</h3>
            <p className="text-gray-600 text-sm">Approvazione per perizie fiscali e dichiarazioni patrimoniali</p>
          </div>
        </div>

        <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-3xl p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-slate-900 mb-8">Validazione Accademica</h3>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-3 h-3 bg-[#E879F9] rounded-full mt-2 mr-4 flex-shrink-0"></div>
                  <div>
                    <h4 className="text-lg font-semibold text-slate-900 mb-2">Università Bocconi - Milano</h4>
                    <p className="text-gray-600">Ricerca congiunta su "Advanced Brand Valuation Methodologies" - Prof. Alessandro Perego, Dipartimento di Management</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-3 h-3 bg-[#22C55E] rounded-full mt-2 mr-4 flex-shrink-0"></div>
                  <div>
                    <h4 className="text-lg font-semibold text-slate-900 mb-2">London Business School</h4>
                    <p className="text-gray-600">Validazione empirica del modello su dataset di 1.200 aziende europee - Prof. Marketing Strategy Department</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-3 h-3 bg-[#E879F9] rounded-full mt-2 mr-4 flex-shrink-0"></div>
                  <div>
                    <h4 className="text-lg font-semibold text-slate-900 mb-2">MIT Sloan School</h4>
                    <p className="text-gray-600">Analisi algoritmica e ottimizzazione parametri - Center for Information Systems Research</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/ef445e7ba9ea9474b223a003819bdb71.jpg"
                alt="Validazione accademica del BCI"
                className="w-full h-96 object-cover rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-slate-900 to-slate-700 text-white rounded-xl text-lg font-medium mb-6">
            <i className="ri-trophy-line text-xl mr-3"></i>
            Awards & Riconoscimenti
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="text-center">
              <h4 className="text-xl font-bold text-slate-900 mb-2">Innovation Award 2023</h4>
              <p className="text-gray-600">European Valuation Standards Board - Miglior metodologia innovativa</p>
            </div>
            
            <div className="text-center">
              <h4 className="text-xl font-bold text-slate-900 mb-2">Excellence in Finance 2023</h4>
              <p className="text-gray-600">Financial Times - Strumento dell'anno per la valutazione aziendale</p>
            </div>
            
            <div className="text-center">
              <h4 className="text-xl font-bold text-slate-900 mb-2">Best Practice 2024</h4>
              <p className="text-gray-600">International Valuation Standards Council - Standard di riferimento</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}